import type { CastPortrait } from './castPortraits.ts'

// Public creator-post previews selected during the October 1 missing-photo pass.
// Keep original permalinks for attribution; the preview helper normalizes thumbnail routes.
export const photoPassPortraits: CastPortrait[] = [
  {
    "personId": "p-florian-sukaj",
    "name": "Florian Sukaj",
    "shortName": "Florian",
    "initials": "FS",
    "platform": "instagram",
    "handle": "@floriansukaj",
    "profileUrl": "https://www.instagram.com/floriansukaj/",
    "postUrl": "https://www.instagram.com/p/C3g7sQesNSX/",
    "postId": "C3g7sQesNSX",
    "mediaKind": "photo",
    "showLabel": "The Last Resort",
    "accessibilitySummary": "A black-and-white solo modeling portrait of Florian standing in a doorway.",
    "tone": "berry",
    "focusY": 10,
    "verificationBasis": "Creator account and post attribution checked against https://www.monstersandcritics.com/tv/reality-tv/florian-sukajs-fans-warn-stacey-silva-to-watch-out-as-90-day-fiance-star-debuts-new-look-looking-fine/ Live platform-hosted thumbnail visually reviewed on 2026-10-01. No media is stored by Journey90."
  },
  {
    "personId": "p-kimberly-rochelle",
    "name": "Kimberly Rochelle",
    "shortName": "Kimberly",
    "initials": "KR",
    "platform": "instagram",
    "handle": "@kimberlyrochelleofficial",
    "profileUrl": "https://www.instagram.com/kimberlyrochelleofficial/",
    "postUrl": "https://www.instagram.com/p/Cv-AeyOtnxF/",
    "postId": "Cv-AeyOtnxF",
    "mediaKind": "photo",
    "showLabel": "The Other Way",
    "tone": "coral",
    "focusY": 20,
    "accessibilitySummary": "Kimberly sits for a solo Roka ceremony portrait in yellow and red, with jewelry and colorful curtains behind her.",
    "verificationBasis": "Creator account and post attribution checked against https://www.monstersandcritics.com/tv/reality-tv/is-90-day-fiance-the-other-way-couple-kim-and-tj-still-together-heres-what-we-know/ Live platform-hosted thumbnail visually reviewed on 2026-10-01. No media is stored by Journey90."
  },
  {
    "personId": "p-gabe-paboga",
    "name": "Gabe Paboga",
    "shortName": "Gabe",
    "initials": "GP",
    "platform": "instagram",
    "handle": "@paboga1",
    "profileUrl": "https://www.instagram.com/paboga1/",
    "postUrl": "https://www.instagram.com/p/CxeBPCcuDjn/",
    "postId": "CxeBPCcuDjn",
    "mediaKind": "photo",
    "showLabel": "The Other Way",
    "tone": "indigo",
    "focusY": 15,
    "accessibilitySummary": "Gabe poses for a mirror selfie in a white tank top and light gray cap.",
    "verificationBasis": "Creator account and post attribution checked against https://www.theashleysrealityroundup.com/2024/03/04/90-day-fiance-star-gabe-pabon-says-he-wife-isabel-posada-are-divorcing-i-cant-put-up-a-front-anymore/ Live platform-hosted thumbnail visually reviewed on 2026-10-01. No media is stored by Journey90."
  }
]
